import React, { Component } from 'react';
import intl from "react-intl-universal";
import {DropdownButton, Dropdown} from 'react-bootstrap';
import ThreeDMapping from "../../img/PM_Cloud_3D_Mapping.png";
import ThreeDMappingSelected from "../../img/PM_Cloud_3D_Mapping_Selected.png";
import GSplatting from "../../img/PM_Cloud_GS_Mapping.png";
import GSplattingSelected from "../../img/PM_Cloud_GS_Mapping_Selected.png";
import TwoDMapping from "../../img/PM_Cloud_2d_Mapping.png";
import TwoDMappingSelected from "../../img/PM_Cloud_2d_Mapping_Selected.png";
import OnlyMe from "../../img/PM_Cloud_Only_Me.png";
import OnlyMeSelected from "../../img/PM_Cloud_Only_Me_Selected.png"
import Everyone from "../../img/PM_Cloud_Everyone.png";
import EveryoneSelected from "../../img/PM_Cloud_Everyone_Selected.png";
import CloseRangeObject from "../../img/CloseRangeObject.png";
import CloseRangeObjectSelected from "../../img/CloseRangeObject_Selected.png";
import WideAreaMapping from "../../img/WideAreaMapping.png";
import WideAreaMappingSelected from "../../img/WideAreaMapping_Selected.png";
import Standard from "../../img/standard.png";
import StandardSelected from "../../img/standard_selected.png";
import RTK_PPK from "../../img/RTK_PPK.png";
import RTK_PPKSelected from "../../img/RTK_PPK_Selected.png";
import * as Common from "../../slCommon";

class newPMProjectPhaseII extends Component {
    constructor(props) {
        super(props);
        this.state = {
            errorMessage: "",
            ThreeDMappingImage: ThreeDMappingSelected,
            GSplattingImage: GSplatting,
            TwoDMappingImage: TwoDMapping,
            OnlyMeImage: OnlyMeSelected,
            EveryoneImage: Everyone,
            CloseRangeObjectImage: CloseRangeObject,
            WideAreaMappingImage: WideAreaMappingSelected,
            StandardImage: StandardSelected,
            RTK_PPKImage: RTK_PPK
        };
    }

    componentDidMount() {
        //Common.createListenForNativeBackOrForwardBtn(this);
    }

    componentWillUnmount() {
        //Common.removeListenForNativeBackOrForwardBtn(this);
    }

    handleErrorMessage = (message) => {
        this.setState({ errorMessgae: message });
    };

    render() {
        return (
            <React.Fragment>
                {this.state.errorMessgae ? (
                    <div className='divWarningPMCloud'>
                        {this.state.errorMessgae}
                    </div>
                ) : null}
                <div style={{ position: 'absolute', paddingBottom: '120px' }}>
                    <div style={{ float: 'left', paddingRight: '20px' }}>
                        <div style={{ marginTop: "40px" }}>
                            <h5 className="moreSpacefromTitleToTable">{intl.get("PM_Cloud_Define_Input_Title")}</h5>
                            <p>{intl.get("PM_Cloud_Define_Input_Select_GPS_Accuracy")}</p>
                            <div style={{ display: 'inline-flex' }}>
                                <div style={{ float: 'left' }}>
                                    <img className={this.props.image1ClassName} src={this.state.StandardImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleIsGPSAccuracy(false);       // GPS Accuracy: Standard
                                        this.setState({ StandardImage: StandardSelected });
                                        this.setState({ RTK_PPKImage: RTK_PPK });
                                        this.props.handlePhaseIIImageClassName("image1ClassName", "PMCloudImageButtons Selected");
                                        this.props.handlePhaseIIImageClassName("image2ClassName", "PMCloudImageButtons");
                                    }} />
                                    <p className='stepIIText'>Standard</p>
                                </div>

                                <div style={{ float: 'right' }}>
                                    <img className={this.props.image2ClassName} src={this.state.RTK_PPKImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleIsGPSAccuracy(true); // GPS Accuracy: RTK/PPK
                                        this.setState({ StandardImage: Standard });
                                        this.setState({ RTK_PPKImage: RTK_PPKSelected });
                                        this.props.handlePhaseIIImageClassName("image2ClassName", "PMCloudImageButtons Selected");
                                        this.props.handlePhaseIIImageClassName("image1ClassName", "PMCloudImageButtons");
                                    }} />
                                    <p className='stepIIText'>RTK / PPK</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "40px" }}>
                            <div>
                                <div style={{ float: 'left' }}>
                                    <p className='stepIIText' style={{fontSize: '1rem'}}>Altitude Method:</p>
                                </div>
                                <div style={{ float: 'right' }}>
                                    <select name="verticalDatum" id="verticalDatum" className="verticalDatumSelectClass" onChange={(event) => {this.props.handleAltitudeMethod(event.target.value)}}>
                                        <option value="Ellipsoid">Absolute - Ellipsoid</option>
                                        <option value="Geoid">Absolute - Geoid (MSL)</option>
                                        <option value="Relative">Relative to Terrain</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "8em" }}>
                            <p className="moreSpacefromTitleToTable">{intl.get("PM_Cloud_Define_Input_Captured_Scene")}</p>
                            <div style={{display: 'inline-flex'}}>
                                <div>
                                    <img className={this.props.image3ClassName} src={this.state.WideAreaMappingImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleCapturedSceneIsWideArea(true);        // Wide Area Mapping
                                        this.setState({ WideAreaMappingImage: WideAreaMappingSelected });
                                        this.setState({ CloseRangeObjectImage: CloseRangeObject });
                                        this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons Selected");
                                        this.props.handlePhaseIIImageClassName("image4ClassName", "PMCloudImageButtons");
                                    }} />
                                    <p className='stepIIText'>Wide Area Mapping</p>
                                </div>
                                <div>
                                    <img className={this.props.image4ClassName} src={this.state.CloseRangeObjectImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleCapturedSceneIsWideArea(false);        // Close Range Object
                                        this.setState({ WideAreaMappingImage: WideAreaMapping });
                                        this.setState({ CloseRangeObjectImage: CloseRangeObjectSelected });
                                        this.props.handlePhaseIIImageClassName("image4ClassName", "PMCloudImageButtons Selected");
                                        this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons");
                                    }} />
                                    <p className='stepIIText'>Close Range Object</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style={{ float: 'right', paddingLeft: '200px' }}>
                        <div style={{ marginTop: "40px" }}>
                            <h5 className="moreSpacefromTitleToTable">{intl.get("PM_CLoud_Select_PhotoMesh_Outputs_Title")}</h5>
                            <p>{intl.get("PM_Cloud_Select_PhotoMesh_Outputs_Description")}</p>
                            <div style={{ display: 'inline-flex' }}>
                                <div>
                                    <img className={this.props.image1ClassName} src={this.state.ThreeDMappingImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleSwitchSelectedPhotoMeshOutputs(this.props.OutputFormatThreeD);
                                        this.props.handlePhaseIIImageClassName("image1ClassName", "PMCloudImageButtons Selected"); // add selected ThreeDMapping
                                        this.props.handlePhaseIIImageClassName("image2ClassName", "PMCloudImageButtons"); // remove selected GSplatting
                                        this.setState({ ThreeDMappingImage: ThreeDMappingSelected });
                                        this.setState({ GSplattingImage: GSplatting });
                                    }} />
                                    <p className='stepIIText'>3D Mesh Model</p>
                                </div>
                                <div>
                                    <img className={this.props.image2ClassName} src={this.state.GSplattingImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleSwitchSelectedPhotoMeshOutputs(this.props.OutputFormatGS);
                                        this.props.handlePhaseIIImageClassName("image2ClassName", "PMCloudImageButtons Selected"); // add selected GSplatting
                                        this.props.handlePhaseIIImageClassName("image1ClassName", "PMCloudImageButtons"); // remove selected ThreeDMapping
                                        this.setState({ GSplattingImage: GSplattingSelected });
                                        this.setState({ ThreeDMappingImage: ThreeDMapping });
                                    }} />
                                    <p className='stepIIText'>Gaussian Splatting</p>
                                </div>
                                <div style={{ marginLeft: "4rem" }}>
                                    <img className={this.props.image3ClassName} src={this.state.TwoDMappingImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        if (this.state.TwoDMappingImage === TwoDMappingSelected) {
                                            this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons");
                                            this.setState({ TwoDMappingImage: TwoDMapping });
                                            this.props.handleSetOrthoPhotoOutputs(false);
                                        }
                                        else {
                                            this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons Selected");
                                            this.setState({ TwoDMappingImage: TwoDMappingSelected });
                                            this.props.handleSetOrthoPhotoOutputs(true);
                                        }
                                    }} />
                                    <p className='stepIIText'>True Orthophoto</p>
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: "8em" }}>
                            <p className="moreSpacefromTitleToTable">{intl.get("PM_Cloud_Who_Can_Access_Title")}</p>
                            <div style={{ display: 'inline-flex' }}>
                                <div>
                                    <img className={this.props.image3ClassName} src={this.state.OnlyMeImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleIsProjectAccessToEveryone(false);
                                        this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons Selected");
                                        this.setState({ OnlyMeImage: OnlyMeSelected });
                                        this.props.handlePhaseIIImageClassName("image4ClassName", "PMCloudImageButtons");
                                        this.setState({ EveryoneImage: Everyone });
                                    }} />
                                    <p className='stepIIText'>My Site</p>
                                </div>
                                <div>
                                    <img className={this.props.image4ClassName} src={this.state.EveryoneImage} onClick={(event) => {
                                        this.setState(this.handleErrorMessage(""));
                                        this.props.handleIsProjectAccessToEveryone(true);
                                        this.props.handlePhaseIIImageClassName("image4ClassName", "PMCloudImageButtons Selected");
                                        this.setState({ EveryoneImage: EveryoneSelected });
                                        this.props.handlePhaseIIImageClassName("image3ClassName", "PMCloudImageButtons");
                                        this.setState({ OnlyMeImage: OnlyMe });
                                    }} />
                                    <p className='stepIIText'>Everyone</p>
                                </div>
                            </div>
                            <p style={{ fontSize: '13px' }}><a href="https://support.skylinesoft.com/hc/en-us/articles/4699178801308" target="_blank">{intl.get("PM_Cloud_Who_Can_Access_Description", { projectName: this.props.projectName, numOfImages: this.props.acceptedPhotos.length })}</a></p>
                        </div>
                    </div>
                </div>
                <div className="NextPrevButtonsClass">
                    <div className="NextButtonDivClass" style={{ float: "right", marginRight: '40px', marginLeft: "30px" }}>
                        <button className="btn-primary btn btn-default NextButtonClass" onClick={(event) => {
                            if (this.props.checkMovingFromPhaseIItoPhaseIII())
                                this.props.setPageNumer(3);
                            else this.handleErrorMessage(intl.get("PM_Cloud_PhaseII_Error_Required_Param_Not_Selected"));
                        }}>START
                        </button>
                    </div>
                    <div className="NextButtonDivClass" style={{ float: "right" }}>
                        <button className="btn-primary btn btn-default NextButtonClass" onClick={(event) => {
                            this.props.setPageNumer(1)
                        }}>Prev
                        </button>
                    </div>
                </div>
            </React.Fragment>
        );
    }
}

export default newPMProjectPhaseII;